import React from "react";

export default function HandleIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 16 16" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.33333 3.99967C6.06971 3.99967 6.66667 3.40272 6.66667 2.66634C6.66667 1.92996 6.06971 1.33301 5.33333 1.33301C4.59695 1.33301 4 1.92996 4 2.66634C4 3.40272 4.59695 3.99967 5.33333 3.99967Z"
        fill={filteredStyles.fill}
      />
      <path
        d="M5.33333 9.33366C6.06971 9.33366 6.66667 8.73671 6.66667 8.00033C6.66667 7.26395 6.06971 6.66699 5.33333 6.66699C4.59695 6.66699 4 7.26395 4 8.00033C4 8.73671 4.59695 9.33366 5.33333 9.33366Z"
        fill={filteredStyles.fill}
      />
      <path
        d="M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z"
        fill={filteredStyles.fill}
      />
      <path
        d="M10.6668 3.99967C11.4032 3.99967 12.0002 3.40272 12.0002 2.66634C12.0002 1.92996 11.4032 1.33301 10.6668 1.33301C9.93045 1.33301 9.3335 1.92996 9.3335 2.66634C9.3335 3.40272 9.93045 3.99967 10.6668 3.99967Z"
        fill={filteredStyles.fill}
      />
      <path
        d="M10.6668 9.33366C11.4032 9.33366 12.0002 8.73671 12.0002 8.00033C12.0002 7.26395 11.4032 6.66699 10.6668 6.66699C9.93045 6.66699 9.3335 7.26395 9.3335 8.00033C9.3335 8.73671 9.93045 9.33366 10.6668 9.33366Z"
        fill={filteredStyles.fill}
      />
      <path
        d="M10.6668 14.6667C11.4032 14.6667 12.0002 14.0697 12.0002 13.3333C12.0002 12.597 11.4032 12 10.6668 12C9.93045 12 9.3335 12.597 9.3335 13.3333C9.3335 14.0697 9.93045 14.6667 10.6668 14.6667Z"
        fill={filteredStyles.fill}
      />
    </svg>
  );
}
